import CookiesService from '../../services/cookies.service';
import { ACTIVE_WALLET_COOKIE_KEY } from '../../store/reducers/Wallet/wallet.types';
import * as log from '../../utils/log';
import { availableWallets, isEnabled as walletIsEnabled, ownStakeAddr } from '../../wallet/api';
const WALLET_COOKIE_KEYS = {
    TYPE: 'type',
    WALLET: 'wallet'
};
export const setCachedWalletCookie = (stakeId, accessToken, refreshToken) => {
    CookiesService.setCookie({
        key: stakeId,
        value: JSON.stringify({
            stakeId,
            accessToken,
            refreshToken,
            type: WALLET_COOKIE_KEYS.WALLET
        })
    });
};
export const setWalletCookies = (walletName, stakeId, accessToken, refreshToken) => {
    setCachedWalletCookie(stakeId, accessToken, refreshToken);
    CookiesService.setCookie({ key: ACTIVE_WALLET_COOKIE_KEY, value: walletName });
};
export const getCachedWalletCookies = (cookies) => {
    return Object.values(cookies).reduce((walletCookies, cookie) => {
        if (cookie.hasOwnProperty(WALLET_COOKIE_KEYS.TYPE) &&
            cookie[WALLET_COOKIE_KEYS.TYPE] === WALLET_COOKIE_KEYS.WALLET) {
            walletCookies.push(cookie);
        }
        return walletCookies;
    }, []);
};
const MaxRetries = 8;
const Delays = [...new Array(MaxRetries)].map((_, i) => Math.pow(1.1, i));
export const installedWallets = async (retry = 0, found = 0) => {
    await delay(250 * Delays[retry]);
    const wallets = availableWallets();
    if (retry >= MaxRetries && wallets.length === 0) {
        log.error('No wallet extensions found.');
        return [];
    }
    else if (wallets.length === found) {
        log.info(`${retry}: Found the wallets ${wallets.length}`);
        return wallets;
    }
    else {
        log.debug(`${retry}: Found more wallets ${found} -> ${wallets.length}`);
        return await installedWallets(retry + 1, wallets.length);
    }
};
const isWalletAvailable = async (name) => {
    const wallets = await installedWallets();
    if (wallets.length === 0)
        return false;
    log.debug('installed wallets:', wallets);
    return wallets.includes(name);
};
export const buildWalletBucket = async (walletItems, cookies) => {
    const walletCookies = getCachedWalletCookies(cookies);
    const wallets = await installedWallets();
    if (wallets.length === 0)
        return [];
    return Promise.all(walletItems.map((item) => getWalletBucketState(item, walletCookies, wallets)));
};
export const resetWalletBucket = async (walletItems) => {
    const wallets = await installedWallets();
    if (wallets.length === 0)
        return [];
    return Promise.all(walletItems.map((item) => getWalletBucketState(item, [], wallets, true)));
};
async function delay(time) {
    return new Promise((resolve) => setTimeout(() => resolve(), time));
}
async function getWalletBucketState({ name, icon }, walletCookies, wallets, reset = false) {
    const walletBucket = {
        name,
        icon,
        isAvailable: false,
        isEnabled: false,
        stakeId: null,
        refreshToken: null,
        accessToken: null
    };
    if (!wallets.includes(name) || wallets.length === 0) {
        return walletBucket;
    }
    walletBucket.isAvailable = true;
    let isEnabled = false;
    try {
        isEnabled = await walletIsEnabled(name);
    }
    catch (exception) {
        log.error(`Error getting the enabled state of ${name} wallet`, exception);
    }
    if (!isEnabled) {
        return walletBucket;
    }
    walletBucket.isEnabled = true;
    let stakeAddr = null;
    try {
        stakeAddr = await ownStakeAddr(name);
    }
    catch (exception) {
        log.error(`Error getting stakeId of ${name} wallet`);
    }
    walletBucket.stakeId = stakeAddr;
    if (!reset) {
        const walletTokens = walletCookies.find(({ stakeId }) => stakeId === stakeAddr);
        if (walletTokens !== undefined) {
            walletBucket.accessToken = walletTokens.accessToken;
            walletBucket.refreshToken = walletTokens.refreshToken;
        }
    }
    return walletBucket;
}
export const getActiveWalletStakeId = async (walletName) => {
    if (await isWalletAvailable(walletName)) {
        return await ownStakeAddr(walletName);
    }
    else {
        return null;
    }
};
export const getActiveWalletCookie = (stakeId, cookies) => {
    if (cookies.hasOwnProperty(stakeId) && cookies[stakeId].type === 'wallet') {
        return cookies[stakeId];
    }
};
export const isJSON = (param) => {
    try {
        JSON.parse(param);
    }
    catch (e) {
        return false;
    }
    return true;
};
